import { mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const Header = styled.div`
  max-width: 630px;
`
export const Caption = styled.h5`
  width: 100%;
  ${mixins.typography.subtitleMedium};
  ${mixins.margin(0)};
`
export const Headline = styled.h1`
  width: 100%;
  ${mixins.typography.headlineXl};
  ${mixins.margin.top(10)};
  ${mixins.margin.bottom(20)};
  ${mixins.media.max.phone} {
    ${mixins.typography.headlineLarge};
  }
`

export const ItemListWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  ${mixins.margin.top(40)}
`

export const ItemWrapper = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: ${mixins.colors.backgroundPrimary};
  border: 1px solid ${mixins.colors.grayLowlight};
  border-radius: 10px;
  ${mixins.margin(5)}
  ${mixins.padding(30, 10)}
  position: relative;

  width: calc(25% - 10px);
  ${mixins.media.max.custom(1280)} {
    width: calc(33% - 10px);
  }
  ${mixins.media.max.desktop} {
    width: calc(50% - 10px);
  }
  ${mixins.media.max.tablet} {
    width: calc(50% - 10px);
  }
  ${mixins.media.max.phone} {
    width: 100%;
  }
  & > button {
    margin-top: auto;
  }
`

export const Title = styled.h2`
  ${mixins.typography.headlineSmall}
  max-width: 350px;
  text-align: center;
  ${mixins.margin.top(0)}
  ${mixins.margin.bottom(30)}
`

export const ProductImage = styled(Asset)`
  ${mixins.margin.bottom(30)}
  width: calc(100%);
  margin-top: auto;
`
export const LearnMoreButtonWrapper = styled.div`
  ${mixins.margin(30)}
`
